<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="task-field">
        <div class="global-label">{{ label }}</div>
        <div>
            <div tabindex="0" class="disp cursor-pointer" v-on="on" @click="$emit('click')">
                <div class="d-flex align-center h-100">
                    <div class="val flex-grow-1 ml-2 font-weight-medium">
                        {{ value ? value : formatOutput(currentState) }}
                    </div>

                    <div class="d-flex align-center ml-3 pr-1">
                        <div
                            v-if="canAddRepeat"
                            class="caption n3--text cursor-pointer add-repeat-btn d-flex align-center font-weight-medium mr-2 transition-ease-in-out hover-text"
                            @click="$emit('add-repeat')"
                        >
                            {{ $t("Add repeat") }}
                        </div>
                        <icon
                            :icon="icon"
                            small
                            :color="menuOpen ? 'primary' : 'n3'"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="errorMessages" class="details error--text">
            {{ errorMessages }}
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { $t } from "@/i18n";
import { ref, computed, watch } from "@vue/composition-api";
import {
    formatRecurrence,
} from "@/plugins/formatting";

export default {
    name: "RecurrenceButton",
    props: {
        label: {
            type: String,
            required: true
        },
        currentState: {
            type: Object,
            required: true
        },
        canAddRepeat: {
            type: Boolean,
            required: true
        },
        menuOpen: {
            type: Boolean,
            required: true
        },
        errorMessages: {
            type: String,
            default: null
        },
        on: {
            type: Object,
            default: null
        },
        value: {
            type: String,
            default: null
        }
    },
    setup(props, ctx) {
        const icon = computed(() => {
            return !props.currentState || !props.currentState.type || props.currentState.type === "date"
                ? "CalendarDays"
                : "RotateCw";
        });

        const formatOutput = (val) => {
            return formatRecurrence(val);
        };

        return {
            icon,
            formatOutput
        };
    }
};
</script>
<style scoped lang="scss">
.date-picker-highlighted.v-text-field {
    ::v-deep label {
        color: var(--v-primary-base) !important;
    }
}

.add-repeat-btn {
    &:hover {
        color: var(--v-primary-base) !important;
    }
}

.task-field {
    min-width: 150px;
}

</style>
